export default "__VITE_ASSET__DmkpXmBI__"